import { NavParams } from 'ionic-angular/navigation/nav-params';
import { Historical } from './../historical/historical';
import { Component, OnInit } from '@angular/core';
import { NavController, ToastController, LoadingController, App } from 'ionic-angular';
import { SigningService } from '../../providers/login';
import { RealTimeService } from '../../providers/real-time.service';
import { HistoricalService } from '../../providers/historical.service';
import { GlobalService } from '../../providers/global.config';
import { DataManagementService } from '../../providers/data-management.service';
import { RealTimeRecord, Group, Vehicule } from '../../objects/real-time';
import { Subscription } from 'rxjs';
import { Storage } from '@ionic/storage';
import { User } from '../../objects/real-time';
import { GroupsPage } from '../groups-page/groups-page';
import { FormBuilder, FormGroup } from '@angular/forms';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { CallNumber } from '@ionic-native/call-number';
import { version } from '../../providers/global.config';
export var serverName2: string = '54.37.88.163';

@Component({
	selector: 'page-home',
	templateUrl: 'home.html'
})
export class HomePage implements OnInit {
	version: String = version;
	token: any;
	buttonColor: string = 'linear-gradient(-225deg, #22E1FF 0%, #1D8FE1 48%, #625EB1 100%)';
	loader: any;
	showing: boolean;
	groups: Group[];
	login: String = null;
	mdp: String = null;
	currentuser: User;
	allGroups: Subscription;
	newRealTimeRecords: RealTimeRecord[] = null;
	oldRealTimeRecords: RealTimeRecord[] = null;
	allRealTimeRecords: Subscription;
	searchWord: string = '';
	loginTest: String = null;
	mdpTest: String = null;
	server: string = '';

	constructor(
		public storage: Storage,
		private navParams: NavParams,
		private historicalService: HistoricalService,
		public app: App,
		public loadingCtrl: LoadingController,
		private realTimeService: RealTimeService,
		private dataManagementService: DataManagementService,
		public navCtrl: NavController,
		private signinService: SigningService,
		private toastController: ToastController,
		private formBuilder: FormBuilder,
		private globalService: GlobalService,
		private iab: InAppBrowser,
		private callNumber: CallNumber
	) {
		//recuperation current user
		this.currentuser = JSON.parse(localStorage.getItem('currentuser'));
		if (this.currentuser) {
			this.login = this.currentuser.username;
			this.mdp = this.currentuser.password;
			this.server = this.currentuser.server;
			//console.log(this.server);
			this.globalService.setservername(this.server);
			// this.Signing();
		}
	}
	ngOnInit() {
		//const browser = this.iab.create('http://fleet.tn/if3/ios/', '_self', { location: 'no' });
	}
	getMyStyles() {
		let myStyles;
		if (this.version == 'finek') {
			myStyles = {
				'background-image': 'url(assets/img/loginWallpaper.jpg)',
				'background-size': 'cover',
				'background-repeat': 'no-repeat',
				'background-position': ' center'
			};
		} else if (this.version == 'fleet') {
			myStyles = {
				'background-image': 'url(assets/img/fleetLogin.jpg)',
				'background-size': 'cover',
				'background-repeat': 'no-repeat',
				'background-position': ' center'
			};
		} else if (this.version == 'traci') {
			myStyles = {
				'background-image': 'url(assets/img/6.jpg)',
				'background-size': 'cover',
				'background-repeat': 'no-repeat',
				'background-position': ' center'
			};
		}

		return myStyles;
	}
	updateservername() {
		console.log(this.server);

		this.globalService.setservername(this.server);
		//console.log(this.globalService.getnominatim_dns());
		//console.log(this.globalService.getservername());
		// serverName2 = this.server;
		//console.log(serverName2);
	}

	//Signing method
	Signing() {
		//this.buttonColor = '#345465';
		this.signinService.login({ username: this.login, password: this.mdp }).subscribe(
			(currentUser) => {
				currentUser.password = this.mdp;
				currentUser.server = this.server;

				console.log(currentUser.server);
				console.log(this.server);
				this.realTimeService.currentuser = currentUser;
				this.historicalService.currentuser = currentUser;
				this.dataManagementService.currentuser = currentUser;
				localStorage.setItem('currentuser', JSON.stringify(currentUser));
				this.goToRt();
			},
			(error) => {
				//console.log('errrrrrrrror', error.status);

				if (error.status == 401) {
					if (this.version == 'fleet'){
						let toast = this.toastController.create({
							message: 'Compte Expiré! Merci de contacter +21623307266',
							showCloseButton: true,
							closeButtonText: 'APPELER'
						});
					    toast.present();
					    toast.onDidDismiss(() => {
						this.callNumber
							.callNumber('+21623307266', true)
							.then((res) => console.log('Launched dialer!', res))
							.catch((err) => console.log('Error launching dialer', err));
					    });
			    	} else if (this.version == 'traci'){
					    let toast = this.toastController.create({
						message: 'Compte Expiré! Merci de contacter votre adminstrateur',
						showCloseButton: true,
						closeButtonText: 'APPELER'
						});
						toast.present();
				    } else if (this.version == 'finek'){
					    let toast = this.toastController.create({
						message: 'Compte Expiré! Merci de contacter votre adminstrateur',
						showCloseButton: true,
						closeButtonText: 'APPELER'
						});
						toast.present();
				    }
		    	} else {
			       let toast = this.toastController.create({
			       message: 'Authentification Echouée!',
				   duration: 2000
			});
			toast.present();
			//this.buttonColor = '#345465';
		}
			}
		);
}
//Make phone call
phoneCall() { }
//GO to Historical

goToRt() {
	this.navCtrl.setRoot(Historical);
}

//GO to Privacy Policy
goToPrivacyPolicy() {
	const browser = this.iab.create('http://traci.tn/if3/policy/TRACI.html');
}
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts